import {
  decryptAccountRecord,
  encryptAccountRecord,
  type EncryptedAccountRecord,
} from '../../db/accountSyncCrypto.ts';
import type { AccountSyncRecord } from './api.ts';
import type {
  BlacklistRow,
  FavoriteRow,
  HistoryRow,
  PrefsRow,
  SavedSearchRow,
} from '../../db/schema.ts';
import type { SourceAuth } from '../../sources/types.ts';

export const ACCOUNT_BUNDLE_STORE = 'bundle';
export const ACCOUNT_BUNDLE_RECORD_KEY = 'local-profile';

export interface AccountDataBundle {
  schemaVersion: 1;
  exportedAt: number;
  stores: {
    favorites: FavoriteRow[];
    history: HistoryRow[];
    blacklist: BlacklistRow[];
    prefs: PrefsRow[];
    savedSearches: SavedSearchRow[];
  };
  sourceAuth: Array<{
    source: string;
    auth: SourceAuth;
    username?: string;
    mode?: 'anonymous';
  }>;
}

export async function encryptAccountDataBundle(
  bundle: AccountDataBundle,
  syncKey: CryptoKey,
  updatedAt = Date.now(),
): Promise<AccountSyncRecord> {
  const encrypted = await encryptAccountRecord(bundle, syncKey);
  return {
    store: ACCOUNT_BUNDLE_STORE,
    key: ACCOUNT_BUNDLE_RECORD_KEY,
    ciphertext: encrypted.ciphertext,
    iv: encrypted.iv,
    updatedAt,
  };
}

export async function decryptAccountBundleRecord(
  record: EncryptedAccountRecord,
  syncKey: CryptoKey,
): Promise<AccountDataBundle> {
  return decryptAccountRecord<AccountDataBundle>(record, syncKey);
}

export async function decryptAccountDataBundleFromRecords(
  records: AccountSyncRecord[],
  syncKey: CryptoKey,
): Promise<AccountDataBundle | undefined> {
  const record = records.find(
    (candidate) =>
      candidate.store === ACCOUNT_BUNDLE_STORE &&
      candidate.key === ACCOUNT_BUNDLE_RECORD_KEY &&
      candidate.deletedAt === undefined,
  );
  if (!record) return undefined;
  return decryptAccountBundleRecord(record, syncKey);
}
